export default "__VITE_ASSET__CxZtrBy5__"